import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { GLOBAL_STATE, INTRO_VIDEOS } from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defautltState, initialState } from './initialState'

export const VIDEOS = GLOBAL_STATE

const videosSlice = createSlice({
  name: VIDEOS,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.introVideos.pending, state => {
        state[INTRO_VIDEOS].loading = true
      })
      .addCase(actionCreators.introVideos.rejected, (state, action) => {
        state[INTRO_VIDEOS].loading = false
        state[INTRO_VIDEOS].error = action.payload as AxiosError
      })
      .addCase(actionCreators.introVideos.fulfilled, (state, action) => {
        state[INTRO_VIDEOS].loading = false
        state[INTRO_VIDEOS].error = null
        state[INTRO_VIDEOS].data = action.payload
      })

    builder.addCase(actionCreators.introVideosClear, state => {
      state[INTRO_VIDEOS] = defautltState()
    })
  },
})

export const { reducer: introVideosReducer } = videosSlice
